import { Currency } from "./general-basic-data";

  
  export enum ImageType  {
    Car,
    Profile,
  }

  export enum SourceFeature1  {
    Favorites,
    Search,
    MyPark
  }

  export class AppConstants{

    static GOOGLE_MAP_ID = "DEMO_MAP_ID";

    static DEFAULT_LATITUDE = 46.8182; //center of switzerland
    static DEFAULT_LONGITUDE = 8.2275;  //center of switzerland
    static DEFAULT_LATITUDE_DLA = 4.033837; //
    static DEFAULT_LONGITUDE_DLA = 9.769621;  //
    static DEFAULT_LATITUDE_OUA = 12.364313; //
    static DEFAULT_LONGITUDE_OUA = -1.519653;  //

    static SCREEN_BREAK_XS = 320;
    static SCREEN_BREAK_SM = 480;
    static SCREEN_BREAK_ME = 768;
    static SCREEN_BREAK_L = 1000;
    static SCREEN_BREAK_XL = 1200;

    // static CAR_PRICE_MIN = 0;
    // static CAR_PRICE_MAX = 100000000;
    // static CAR_PRICE_STEP = 100000;

    static CAR_PRICE = {
      SALE: {
        MIN: 0,
        MAX: 100000000,
        STEP: 100000
      },
      RENTAL:{
        MIN: 0,
        MAX: 1000000,
        STEP: 10000
      }
    }

    static CAR_YEAR_MIN = 1980;

    static PAGE_SIZE_DEFAULT = 12;
    static PAGE_SIZE_OPTIONS = [2, 4, 8, 12];

    static COUNTRY_CODE_DEFAULT: string = 'CM';
    static COUNTRY_CURRENCY_DEFAULT: Currency.XAF;
    
    static COUNTRY_CODE_OPTIONS = ["CM", "GA", "SN", "BF", "CI", "ML", "BJ"];

    static EMAIL_REGEX: string = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";
    static PHONE_NUMBER_REGEX: string = "[0-9]{6,14}";

    static getSelectedCountryCodeDefault(): string{
      return this.COUNTRY_CODE_DEFAULT;
    }

  }